export default __webpack_public_path__ + "static/macOS_desktop_updated-f67ab3cd4dede2aeeaf05e4effa96cd8.png";